import { Injectable } from '@angular/core';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class ParentalUtilsService {

  constructor(private UTS: UtilitiesService) { }

  getRelatedAddon(accountType: String){
    let selectedSku;
    if(sessionStorage.getItem('parentalControlAddons')){
      let parentalControlAddons = JSON.parse(sessionStorage.getItem('parentalControlAddons'));
      if(parentalControlAddons?.length){
        let product = parentalControlAddons.filter(p => p?.skus?.[0]?.vasIsEligibleForAccountType === accountType);
        if(product && product?.length > 0) selectedSku = product[0];
        return selectedSku || null;
      }

    }
  }
  navigateAddonDetailUrl(selectedSku: any){
    if(selectedSku && selectedSku?.skus?.length){
      const skuId = selectedSku?.skus[0].skuId;
      return `/addon/detail?skuId=${skuId}&lang=${this.UTS.getLocaleLanguage()}`;
      // this.router.navigateByUrl(`/addon/detail?skuId=${skuId}&lang=${this.UTS.getLocaleLanguage()}`);
    }
  }
  setSelectedAccount(account: any){
    sessionStorage.setItem('parentalSelectedAccount', JSON.stringify(account));
  }
  getSelectedAccount(){
    if(sessionStorage.getItem('parentalSelectedAccount')){
      return JSON.parse(sessionStorage.getItem('parentalSelectedAccount'));
    }
    return null;
  }
}
